import { render, staticRenderFns } from "./EditSignature.vue?vue&type=template&id=1d67539a&"
import script from "./EditSignature.vue?vue&type=script&lang=js&"
export * from "./EditSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d67539a')) {
      api.createRecord('1d67539a', component.options)
    } else {
      api.reload('1d67539a', component.options)
    }
    module.hot.accept("./EditSignature.vue?vue&type=template&id=1d67539a&", function () {
      api.rerender('1d67539a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/EditSignature.vue"
export default component.exports